import {IShiftReport} from 'common/interfaces/ishiftReport';
import {formatDateTime} from './date-util';
import {DATE_FORMATS, ShiftReportStatusEnum} from 'common/constants';
import moment from 'moment';
import {IShiftConfig, IUserShift} from 'common/interfaces/ishift';

export const getShiftTimingDisplay = (startTime: string, endTime: string) => {
  return (
    moment(startTime, 'HH:mm:ss').format('HH:mm') +
    '-' +
    moment(endTime, 'HH:mm:ss').format('HH:mm')
  );
};

export const formatShiftTime = (shiftTime: any) => {
  if (!shiftTime) {
    return '';
  }
  return moment(shiftTime, 'HH:mm:ss').format('hh:mm A');
};

export const getShiftName = (shift: IUserShift, fullName?: boolean) => {
  if (fullName) {
    const time =
      formatShiftTime(shift.configStartTime) +
      '-' +
      formatShiftTime(shift.configEndTime);
    if (shift.shiftName) {
      return shift.shiftName + ' (' + time + ')';
    } else {
      return time;
    }
  } else {
    if (shift.shiftName) {
      return shift.shiftName;
    } else {
      const time =
        formatShiftTime(shift.configStartTime) +
        ' - ' +
        formatShiftTime(shift.configEndTime);
      return time;
    }
  }
};

export const getShiftDisplayName = (
  startTime: number | string,
  endTime: number | string,
  shiftName: string,
) => {
  return (
    shiftName +
    ' (' +
    (formatShiftTime(startTime) + '-' + formatShiftTime(endTime)) +
    ')'
  );
};

export const getShiftConfigDisplayName = (shiftConfig: IShiftConfig) => {
  return (
    shiftConfig.shiftName +
    ' (' +
    (formatShiftTime(shiftConfig.startTime) +
      '-' +
      formatShiftTime(shiftConfig.endTime)) +
    ')'
  );
};

export const getShiftReportTitle = (
  report?: IShiftReport | null | undefined,
  useTimings?: boolean,
) => {
  if (!report) {
    return '';
  }
  let name = report.name;
  if (!name && useTimings && report.shiftStartTime && report.shiftEndTime) {
    name = getShiftTimingDisplay(report.shiftStartTime, report.shiftEndTime);
  }
  return (
    (name || 'Shift Report') + '  #' + report?.shiftId + '.v' + report?.version
  );
};

export const getShiftReportDisplayDate = (
  item: IShiftReport | null | undefined,
  format: string = DATE_FORMATS.YYYYMMDD,
) => {
  if (!item || !item.reportDate) {
    return '';
  }
  return moment(item.reportDate).format(format);
};

export const getReportDisplayDate = (
  submittedTime: string | undefined,
  updatedTime: string | undefined,
  createdTime: string | undefined,
  format: string = DATE_FORMATS.YYYYMMDD,
) => {
  let date = updatedTime
    ? formatDateTime(new Date(updatedTime), format)
    : undefined;
  if (!date && submittedTime) {
    date = submittedTime ? formatDateTime(new Date(submittedTime), format) : '';
  } else if (!date && createdTime) {
    date = createdTime ? formatDateTime(new Date(createdTime), format) : '';
  }
  return date;
};

export const getShiftReportDisplayStatus = (
  status: ShiftReportStatusEnum | undefined | null,
) => {
  if (!status) {
    return '';
  }
  switch (status) {
    case ShiftReportStatusEnum.DRAFT:
      return 'shiftReport.status.draft';
    case ShiftReportStatusEnum.SUBMITTED:
      return 'shiftReport.status.submitted';
    case ShiftReportStatusEnum.UNDER_REVIEW:
      return 'shiftReport.status.under_review';
    case ShiftReportStatusEnum.APPROVED:
      return 'shiftReport.status.approved';
  }
  return '';
};

export const getReportStatusTextStyleName = (status: ShiftReportStatusEnum) => {
  switch (status) {
    case ShiftReportStatusEnum.DRAFT:
      return 'listItemStatusDraft';
    case ShiftReportStatusEnum.UNDER_REVIEW:
      return 'listItemStatusUnderReview';
    case ShiftReportStatusEnum.APPROVED:
      return 'listItemStatusApproved';
    case ShiftReportStatusEnum.SUBMITTED:
      return 'listItemStatusSubmitted';
  }
  return 'listItemText';
};
